import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers/translator.reducer';

export const getStore = createFeatureSelector<fromReducers.State>('translator');

export const getCurrentLanguage = createSelector(
  getStore,
  (state) => state.lang
);